
import { computed, defineComponent } from 'vue';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';

export default defineComponent({
  name: 'SBtnEsia',
  components: { SBtn },
  setup(props, { slots }) {
    const { isDesktop } = useDeviceSize();

    const label = computed(() => {
      return isDesktop.value ? 'Войти через ЕСИА' : 'Войти';
    });

    return { props, slots, label };
  },
});
